import { useUser } from "@/providers/context";
import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { ProgressEvent, putProgressEvent } from "@/api";

export const usePutProgressEvent = () => {
  const { uid } = useUser();
  return useMutation<unknown, AxiosError<{ detail: string }>, ProgressEvent>(
    (variables) => {
      if (!uid) {
        return Promise.reject();
      }
      return putProgressEvent({ ...variables, UserId: uid });
    },
  );
};
